import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
export const goUrl = (id, src) => `${API}/go/${encodeURIComponent(id)}?src=${src}`;

export const CALLBACK_TIMES = ["Morning (9 AM – 12 PM)", "Afternoon (12 PM – 4 PM)", "Evening (4 PM – 8 PM)", "Anytime"];

export const SEGMENTS = [
  { value: "land_property", label: "Land & Property / Real Estate", reg: "RERA Code" },
  { value: "mutual_funds", label: "Mutual Fund Distribution", reg: "AMFI ARN" },
  { value: "stock_broking", label: "Stock Broking / Demat", reg: "SEBI Registration Number" },
  { value: "algo_tech", label: "Algo & Quant Tech / Advisory", reg: "SEBI Registration Number" },
  { value: "safe_guaranteed", label: "Insurance, Pensions & Fixed Income", reg: "IRDAI / PFRDA Registration Number" },
];

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace("Value error, ", "")).join(" ");
  return String(d);
};

export const phone10 = (s) => {
  const d = s.replace(/\D/g, "");
  return (d.length > 10 ? d.replace(/^(91|0)/, "") : d).slice(-10);
};
